<nav class="admin-sidenav" aria-label="Navegação administrativa">

  <div class="admin-sidenav-header">
    <span class="admin-brand">
      <span class="admin-brand-mark" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" rx="6" fill="var(--compleet-color-primary, #3B82F6)"/>
          <path d="M6 12L10 16L18 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="admin-brand-text">
        <span class="admin-brand-product">Compleet</span>
        <span class="admin-brand-area">Área Administrativa</span>
      </span>
    </span>
  </div>

  <dx-tree-view
    class="admin-tree-view"
    [items]="navItems()"
    keyExpr="id"
    displayExpr="text"
    selectionMode="single"
    [selectByClick]="true"
    [searchEnabled]="false"
    (onItemClick)="onItemClick($event)">
  </dx-tree-view>

</nav>
